import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  getUserFromToken () {
    return Vue.http.get(urls.GET_USER_FROM_TOKEN_URL, {'headers': authHeaders.getAuthHeaders()})
  },
  createUser (username, password1, password2, email) {
    let body = JSON.stringify({ username, password1, password2, email })
    return Vue.http.post(urls.REGISTRATION_URL, body)
  },
  isLoginExisting (login) {
    let url = urls.CHECK_LOGIN_URL + login + '/'
    return Vue.http.get(url)
  },
  getUserList () {
    return Vue.http.get(urls.GET_USER_FROM_PK_URL, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/user.api.js